module.exports = __webpack_public_path__ + "img/Philippines.117a72b8.svg";